import React, { useContext, useEffect, useState } from 'react';
// External library imports
import { toast } from 'react-toastify';
import moment from 'moment';
import { get as lodashGet, has as lodashHas } from 'lodash';
import { useLoader, useUserRole } from '../../../../hooks';
import Table from '../../../../components/Table/Table';
import Typography from '../../../../components/Typography/Typography';
import { momentTimeFormater } from '../../../../utils/dateHelper';
import Checkbox from '../../../../components/Inputs/Checkbox/Checkbox';
import { DropdownComponent } from '../../../../components/Inputs/Input';
import DeleteModal from '../../../../components/DeleteModal/DeleteModal';
import { ConfigContext } from '../../../../context/ConfigContext';
import DatePicker from '../../../../components/Inputs/DatePicker/DatePicker';
import allDeviceClasses from '../../../../styles/AllDevices.module.css';
import bidClasses from '../Bidding.module.css';
import { RootBidCredentialsService } from '../../../../services/BiddingService/Root/BidCredentialService';
import { RootBiddingService } from '../../../../services/BiddingService/Root/BiddingService';
import { InstanceService } from '../../../../services/BiddingService/CommonServices/InstanceService';
import { AdminBidCredentialsService } from '../../../../services/BiddingService/Admin/BidCredentialService';
import { AuthContext } from '../../../../context/AuthContext';
import { AdminBiddingService } from '../../../../services/BiddingService/Admin/BiddingService';
import MultiSelectDropdown from '../../../../components/Inputs/MultiSelectDropdown';
import { Form, Formik } from 'formik';

const AREA_OPTION = [
    {
        label: 'DK1',
        value: 'DK1',
    },
    {
        label: 'DK2',
        value: 'DK2',
    },
];

export const PostResouceSchedule = ({ closeModal, getLogs = null }) => {
    const { state } = useContext(AuthContext);
    const { isRootUser } = useUserRole();
    const service = isRootUser ? RootBiddingService : AdminBiddingService;
    const userBidMarkets = lodashGet(state, 'user.config.biddingMarkets');

    const {
        state: { marketGroup },
    } = useContext(ConfigContext);
    const [startLoader, stopLoader] = useLoader();
    const [date, setDate] = useState(moment().add(1, 'day').toDate());
    const [instances, setInstances] = useState([]);
    const [bidCredOption, setBidCredOption] = useState([]);
    const [selectedBidCred, setSelectedBidCred] = useState([]);
    const [lastPostedAt, setLastPostedAt] = useState(null);
    const [confirmModal, setConfirmModal] = useState(false);
    const [selectedArea, setSelectedArea] = useState(AREA_OPTION[0]);

    useEffect(() => {
        getBidCredentials();
    }, []);

    useEffect(() => {
        if (selectedBidCred?.length) getInstances();
    }, [selectedBidCred?.length, selectedArea]);

    useEffect(() => {
        if (lodashGet(selectedBidCred, [0, 'value']) && date) getBidHistory();
    }, [lodashGet(selectedBidCred, [0, 'value']), date]);

    const getBidCredentials = () => {
        if (isRootUser) RootBidCredentialsService.GetAll(startLoader, handleBidCredentialSuccess, handleError, stopLoader);
        else {
            const credIds = [];
            for (const market in userBidMarkets) {
                lodashHas(userBidMarkets, `[${market}].credentials`) &&
                    lodashGet(userBidMarkets, `[${market}].enabled`, false) &&
                    credIds.push(lodashGet(userBidMarkets, `[${market}].credentials`));
            }
            AdminBidCredentialsService.GetAll({ credIds }, startLoader, handleBidCredentialSuccess, handleError, stopLoader);
        }
    };

    const handleBidCredentialSuccess = ({ data }) => {
        const bidCredentials = [];
        lodashGet(data, ['data'], []).forEach((item) => {
            if (marketGroup.AFRR.some((groupMarket) => item.market.includes(groupMarket))) {
                bidCredentials.push({
                    label: item.name,
                    value: item._id,
                    market: item.market,
                });
            }
            if (marketGroup.MFRR.some((groupMarket) => item.market.includes(groupMarket))) {
                bidCredentials.push({
                    label: item.name,
                    value: item._id,
                    market: item.market,
                });
            }
        });
        setBidCredOption(bidCredentials);
        setSelectedBidCred([lodashGet(bidCredentials, [0], {})]);
    };

    const getBidHistory = () => {
        const params = {
            credentialId: lodashGet(selectedBidCred, [0, 'value']),
            date: momentTimeFormater(date).format('YYYY-MM-DD'),
            type: 'resourceSchedule',
        };
        service.GetLastDocPosted(params, startLoader, handleBidHistorySuccess, handleError, stopLoader);
    };

    const handleBidHistorySuccess = ({ data }) => {
        setLastPostedAt(lodashGet(data, ['data', 'updatedAt'], null));
    };

    const getInstances = () => {
        const params = {
            bidCredId: selectedBidCred.map((el) => el.value),
            area: selectedArea?.value,
        };
        InstanceService.GetInstanceApprovedCapacity(params, startLoader, handleSuccess, handleError, stopLoader);
    };

    const getCheckBox = (item) => {
        return (
            <div className={bidClasses.Flex} style={{ justifyContent: 'center' }}>
                <Checkbox onChange={(isChecked) => getCheckedInstances(isChecked, item)} checked={item.checked} />
            </div>
        );
    };

    const getCheckedInstances = (checked, ins) => {
        setInstances((prev) =>
            prev.map((item) => {
                if (item.id === ins.id) {
                    item.checked = checked;
                    item.select = getCheckBox(item);
                    return item;
                } else return item;
            })
        );
    };

    const handleSuccess = ({ data }) => {
        const temp = [];
        lodashGet(data, ['data'], []).map((el) => {
            temp.push({
                ...el,
                approvedCapacity: el.approvedCapacity || '--',
                fuelType: el.fuelType || '--',
                select: getCheckBox(el),
            });
        });
        setInstances(temp || []);
    };

    const handleSubmit = () => {
        if (selectedBidCred?.length) {
            const currentCETTime = momentTimeFormater(momentTimeFormater().format('YYYY-MM-DD HH:mm'));
            // if (
            //     !currentCETTime.isAfter(
            //         momentTimeFormater(momentTimeFormater(date).subtract(1, 'days').set({ hour: 23, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD HH:mm'))
            //     )
            // ) {
            const temp = [];
            instances.map((ins) => {
                if (ins.checked) {
                    delete ins.select;
                    temp.push(ins);
                }
            });
            const payload = {
                bidCredId: selectedBidCred.map((el) => el.value),
                instanceData: temp,
                date: momentTimeFormater(date).format('YYYY-MM-DD'),
                type: 'resourceSchedule',
            };
            service.PostResourceSchedule(payload, startLoader, handlePostSuccess, handleError, stopLoader);
            // } else toast.error('Can not post resource schedule for tomorrow after 11PM (CET)');
        }
    };

    const handlePostSuccess = () => {
        toast.success('Resource schedule send to energinet successfully');
        closeModal();
        if (getLogs) getLogs();
    };

    const handleError = (err) => toast.error(lodashGet(err, ['response', 'data', 'message']));

    return (
        <div>
            <div className={bidClasses.MainModalContainer}>
                <div className={bidClasses.DateContainer}>
                    <Typography content={`Post Resource Schedule`} />
                    <div className={bidClasses.Flex}>
                        <div>
                            <Formik enableReinitialize initialValues={{ credential: [] }}>
                                {({}) => (
                                    <Form>
                                        <div className={allDeviceClasses.FieldControl2}>
                                            <label>Credential</label>
                                            <MultiSelectDropdown
                                                name="credential"
                                                options={bidCredOption}
                                                defaultValue={selectedBidCred}
                                                onChange={(e) => {
                                                    if (e.length) setSelectedBidCred(e);
                                                }}
                                            />
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                        <div className={allDeviceClasses.FieldControl2} style={{ width: '10vw' }}>
                            <label>Area</label>
                            <div className={bidClasses.DropdownContainer}>
                                <DropdownComponent defaultValue={selectedArea} options={AREA_OPTION} onChange={(e) => setSelectedArea(e)} />
                            </div>
                        </div>
                        <div className={allDeviceClasses.FieldControl2} style={{ width: '8vw' }}>
                            <label>Date</label>
                            <div className="modal-date-picker">
                                <DatePicker date={date} setDate={(d) => setDate(d)} disableFutureDate={false} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={bidClasses.MainContainer}>
                    <div className={bidClasses.Flex} style={{ justifyContent: 'flex-end' }}>
                        {lastPostedAt && <div className={bidClasses.InstanceName}>Last Posted (CET): {momentTimeFormater(lastPostedAt).format('YYYY-MM-DD HH:mm')}</div>}
                    </div>
                    <Table
                        head={['Select', 'Customer Name', 'Instance', 'Market', 'Approved Capacity', 'Fuel Type']}
                        keys={['select', 'customer', 'instance', 'market', 'approvedCapacity', 'fuelType']}
                        data={instances}
                    />
                </div>

                <div>
                    <div className={allDeviceClasses.ButtonContainer}>
                        <div onClick={closeModal}>
                            <button type="button" className="btn-secondary">
                                Cancel
                            </button>
                        </div>
                        <div onClick={() => (lastPostedAt ? setConfirmModal(true) : handleSubmit())}>
                            <button type="submit" className="btn-primary">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <DeleteModal
                deletefunction={handleSubmit}
                opendeleteModal={confirmModal}
                setOpenDeleteModal={setConfirmModal}
                title={<div style={{ textAlign: 'center' }}>Are you sure you wish to submit your availability plan?</div>}
                text={'A availability plan has already been recorded for your selected options.'}
            />
        </div>
    );
};
